import React, { useEffect, useState } from 'react';
// import { Box, FormControl, InputLabel, Select, MenuItem, Button, Typography } from '@mui/material';
import { Accordion, AccordionSummary, AccordionDetails, Card, CardContent, Box, FormControl, InputLabel, Select, MenuItem, Button, Typography, Modal } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_LIVE_COMPETITIONS, GET_LIVE_FIXTURES } from '../graphql/queries';
import { useAuth } from '../AuthContext';


const DropdownPage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const token = localStorage.getItem('token');
  const username = localStorage.getItem('username');
  if (!token || !username) {
    navigate('/');
  }

  const [fixtures, setFixtures] = useState(null);
  const [selectedFixture, setSelectedFixture] = useState({});
  const [activeCompetitions, setActiveCompetitions] = useState([]);
  const [selectedCompetition, setSelectedCompetition] = useState({});
  const [openModal, setOpenModal] = useState(false)
  // const isMobile = useMediaQuery({ query: '(max-width: 767px)' }); // Define mobile as less than 768px

  const liveFixtures = useQuery(GET_LIVE_FIXTURES, {
    variables: { token, compId: selectedCompetition?.extCompetitionId },
    fetchPolicy: 'no-cache'
  });

  const liveCompetitions = useQuery(GET_LIVE_COMPETITIONS, {
    variables: {  dbName: 'aether-db-fifa', token: token },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (liveFixtures.data) {
      setFixtures(liveFixtures.data.liveFixtures);
    }
    if (liveFixtures.error) {
      logout();
    }
    
  }, [liveFixtures]);

  const onSelect = (fixture) => {
    setSelectedFixture(fixture);
    localStorage.setItem('selectedFixture', JSON.stringify(fixture));
    navigate('/togglepage');
  };

  useEffect(() => {
    if (liveCompetitions.data) {
      setActiveCompetitions(liveCompetitions.data.getFinishedCompetitions);
    }
  }, [liveCompetitions]);

  const handleCompetitionChange = (event) => {
    const selectedCompetition = event.target.value;
    if (selectedCompetition) {
      setSelectedCompetition(selectedCompetition);
    } else {
      selectedCompetition(null)
    }
  }

  return (

    <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100vh',
      overflowY: 'auto', // Enable scrolling when content overflows
      borderRadius: 2,
      boxShadow: 3,
      background: 'black',
      paddingTop: { xs: '76px', sm: '76px' }, // Adjust padding to account for AppBar height
    }}
  >
    <Modal open={openModal} onClose={()=>setOpenModal(false)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          alignItems: 'left',
          height: 'content-fit',
          width: { xs: '90%', sm: '80%', md: '600px', lg: '600px' }, // Responsive width
          overflowY: 'auto', // Enable scrolling when content overflows
          borderRadius: 2,
          boxShadow: 3,
          background: '#fff',
          gap: 2,
          padding: { xs: '2%', sm: '2%' }, // Adjust padding to account for AppBar height
        }}
      >
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Competition</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedCompetition}
              label="Select Competition"
              onChange={(e)=>handleCompetitionChange(e)}
            >
             {activeCompetitions && activeCompetitions.map(ac => <MenuItem value={ac}>{ac?.competitionName}</MenuItem>)}
            </Select>
          </FormControl>
      </Box>
    </Modal>
    <Typography
      variant="h5"
      sx={{
        fontWeight: 'bold',
        fontFamily: 'Lato, sans-serif',
        color: 'white',
        textAlign: 'center', // Ensure central alignment
      }}
    >
      {selectedCompetition?.competitionName
        ? selectedCompetition?.competitionName
        : 'All Competitions'}
      <Button onClick={()=>setOpenModal(true)} 
        sx={{
          color: '#fff', 
          marginLeft: 4, 
          fontWeight: 'bold', 
          fontFamily: 'Lato, sans-serif',
          border: '1px solid #fff'
        }}
      >Select Compettion</Button>
    </Typography>
  
   
  <Box
    sx={{
      borderRadius: 2,
      margin: '15px',
      padding: '15px',
      background: '#E8E8E8',
      width: { xs: '90%', sm: '80%', md: '00px', lg: '600px' }, // Responsive width
      maxHeight: { xs: 'none', sm: 'calc(100vh - 120px)' }, // Remove height limit on small screens
      overflowY: 'scroll', // Enable scrolling
      // Hide scrollbar while keeping scroll functionality
      '&::-webkit-scrollbar': {
        width: '0px', // Hide scrollbar for webkit browsers
        background: 'transparent',
      },
      scrollbarWidth: 'none', // Hide scrollbar for Firefox
    }}
  >
      {fixtures && fixtures?.length > 0 ? (
        fixtures.map((fixture, index) => {
          const startDate = new Date(Number(fixture.startDateTime));
          const formattedStartDate = startDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          });
  
          return (
            <Box key={index} sx={{ marginBottom: 2 }}>
              <Card
                sx={{
                  padding: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <CardContent sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 'bold',
                      fontFamily: 'Lato, sans-serif',
                    }}
                  >
                    {fixture.fixtureName}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                    }}
                  >
                    {formattedStartDate}
                  </Typography>
                </CardContent>
                <Button
                  variant="contained"
                  onClick={() => onSelect(fixture)}
                  sx={{
                    backgroundColor: 'black',
                    color: 'white',
                    marginLeft: 1,
                    '&:hover': {
                      backgroundColor: 'grey.800',
                    },
                  }}
                >
                  Select
                </Button>
              </Card>
            </Box>
          );
        })
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            color: 'black',
          }}
        >
          <Typography variant="h6" fontWeight="bold">{fixtures?.length === 0 ? "No fixtures available" : "Loading..."}</Typography>
        </Box>
      )}
    </Box>
  </Box>
  

  );
};

export default DropdownPage;
